export const bankDetails = {
  AccountName: "AIFA ENVIRONMENTAL SERVICES & PEST CONTROL LLC",
  BANKNAME: "RAK BANK",
  ACCOUNTNO: " 0332815465001",
  IBANNO: "AE920400000332815465001",
  SWIFTCODE: "NRAKAEAK",
  BANKADDRESS: "RAK BANK BUILDING, UMM HURRAIR BUR DUBAI",
  BRANCHNAME: "UMM HURRAIR,DUBAI",
  BANKTELNO: "04-2130000",
};
